// components/ClaritySetup.tsx
"use client";

import { useEffect } from "react";
import Clarity from "@microsoft/clarity";

export default function ClaritySetup() {
  useEffect(() => {
    // The project ID is from your error message
    Clarity.init("shlnlwirt4");
  }, []);

  // This component renders nothing to the page
  return null;
}
